import {
    BORDER_HIDDEN,
    SelectField,
    STYLE_BASIC,
} from '@eventbrite/eds-input-field';
import { getSelectPropValues } from '@eventbrite/eds-select';
import { gettext } from '@eventbrite/i18n';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import React, { FunctionComponent } from 'react';
import type { Locale } from '../../api/models/locale';
import styles from './LanguageSelector.module.scss';

const getLanguages = (locales: Array<Locale>) => {
    const unsupportedLocales = [
        'en_IE',
        'en_NZ',
        'en_HK',
        'en_SG',
        'de_AT',
        'fr_BE',
        'nl_BE',
        'es_PE',
        'es_CL',
        'es_CO',
    ];

    return sortBy(
        // Don't display locales that aren't supported on Event Type/Language
        filter(locales, ({ locale }) => !unsupportedLocales.includes(locale)),
        'localized_language_name',
    );
};

export interface LanguageSelectorProps {
    defaultLocale: string;
    locales: Array<Locale>;
    onChange?: (newValue: string, index: number) => void;
}

export const LanguageSelector: FunctionComponent<LanguageSelectorProps> = ({
    defaultLocale,
    locales,
    onChange,
}) => {
    return (
        <div className={styles.languageLabelAndSelector}>
            <span
                className={`${styles.languageLabel} eds-text-color--grey-600`}
                data-testid="language-selector-label"
            >
                {gettext('Language:')}
            </span>
            <SelectField
                borderType={BORDER_HIDDEN}
                defaultValue={defaultLocale}
                data-automation="language-dropdown"
                id="language-select-field"
                label={gettext('Select your language')}
                name="language-select-field"
                onChange={onChange}
                role={null}
                style={STYLE_BASIC}
                values={getSelectPropValues(
                    getLanguages(locales),
                    'localized_language_name',
                    'locale',
                )}
            />
        </div>
    );
};
